import { useEffect, useState } from 'react';

import { Loader } from '@googlemaps/js-api-loader';
import { CONFIG } from '@frontend/config';

const apiConfig = {
  id: 'google-map-script',
  version: 'weekly',
  apiKey: CONFIG.GOOGLE_KEY,
};

let isGoogleMapsApiLoaded = false;

export const useGoogleMapsApiLoader = () => {
  const [isLoaded, setIsLoaded] = useState(isGoogleMapsApiLoaded);
  const [maps, setMapsLib] = useState<google.maps.MapsLibrary | null>(null);
  const [places, setPlacesLib] = useState<google.maps.PlacesLibrary | null>(null);

  useEffect(() => {
    if (isGoogleMapsApiLoaded) {
      setIsLoaded(true);
    } else {
      const loader = new Loader(apiConfig);
      Promise.all([loader.importLibrary('maps'), loader.importLibrary('places')])
        .then(([maps, places]) => {
          setMapsLib(maps);
          setPlacesLib(places);
          isGoogleMapsApiLoaded = true;
          setIsLoaded(true);
        })
        .catch((e) => {
          console.error('Error loading Google Maps API:', e);
        });
    }
  }, []);

  return {
    isLoaded,
    maps,
    places,
  };
};
